import { useTranslation } from "react-i18next";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    Grid,
    CardActions
} from "@mui/material";
import { MapitPasswordTextField } from "src/components/common";
import { LoadingButton } from '@mui/lab';
import { ROLES, USER_ROLES_TYPES } from "src/constants";

export default function ChangePasswordCard({ passwordData, onChange, onUpdatePassword, loading, isSuccess, error, validationErrors, role, type }) {
    const { t } = useTranslation();

    return (
        <form autoComplete="off" noValidate>
            <Card>
                <CardHeader title={t("Password")} />
                <Divider />
                <CardContent>
                    <Grid container spacing={3}>
                        {role !== ROLES.admin &&
                            <Grid item xs={12}>
                                <MapitPasswordTextField
                                    size="small"
                                    label={t("Current Password")}
                                    name="currentPassword"
                                    value={passwordData?.currentPassword ?? ''}
                                    required={true}
                                    handleChange={onChange}
                                    error={validationErrors?.currentPassword}
                                />
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <MapitPasswordTextField
                                size="small"
                                label={t("New Password")}
                                name="password"
                                value={passwordData?.password ?? ''}
                                required={true}
                                handleChange={onChange}
                                error={validationErrors?.password}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MapitPasswordTextField
                                size="small"
                                label={t("Confirm password")}
                                name="confirm"
                                value={passwordData?.confirm ?? ''}
                                required={true}
                                handleChange={onChange}
                                error={validationErrors?.confirm}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <Divider />
                <CardActions
                    sx={{
                        display: "flex",
                        justifyContent: error || isSuccess ? "space-between" : "flex-end",
                        alignItems: 'center',
                    }}
                >
                    {!!error && <Typography color='text.danger'>{t(error)}</Typography>}
                    {isSuccess && <Typography color='success.main'>{t("Done successfully")}</Typography>}
                    <LoadingButton
                        color="main"
                        variant="contained"
                        disableElevation
                        disabled={type === USER_ROLES_TYPES.SUB_ADMIN}
                        onClick={onUpdatePassword}
                        loading={loading}
                        sx={{
                            mt: 1,
                            textTransform: "none",
                            fontWeight: "bold",
                        }}
                    >
                        {t("Update")}
                    </LoadingButton>
                </CardActions>
            </Card>
        </form>
    );
};
